<template>
  <b-container fluid>
    <b-row class="ctrl-dir">
      <b-col cols="8">
        <div class="pdf-viewer">
          <div v-show="!showViewer" class="pdf-loading">
            <div class="spinner">
              <div class="bounce1"></div>
              <div class="bounce2"></div>
              <div class="bounce3"></div>
            </div>
          </div>
          <b-container v-show="showViewer" fluid>
            <div class="bread-crumb">
              <p class="bread-crumb-items">
                <i class="fas fa-home"></i>
                <i class="far fa-chevron-right"></i>
                <b-link class="bread-crumb-link" :to="book.booksMenuUrl">
                  {{ book.booksMenuTitle }}
                </b-link>
              </p>
            </div>
            <b-row class="pdf-viewer-controls">
              <b-col cols="3" class="pdf-pages">
                <b-input-group size="sm">
                  <b-input-group-prepend>
                    <b-btn @click="prevPage" variant="info">
                      <i class="fal fa-chevron-circle-left"></i>
                    </b-btn>
                  </b-input-group-prepend>
                  <b-form-input inline v-model="pdfPageIndex" type="number" min="1" :max="pdfTotalPages"></b-form-input>
                  <b-input-group-append>
                    <b-btn @click="nextPage" variant="info">
                      <i class="fal fa-chevron-circle-right"></i>
                    </b-btn>
                  </b-input-group-append>
                </b-input-group>
              </b-col>
              <b-col cols="9" class="pdf-scales">
                <span class="page-stastic">{{ pdfPageIndex }} / <span ref="totalPages"></span></span>
              </b-col>
            </b-row>
          </b-container>
          <transition name="fade">
            <div v-show="showViewer" class="pdf-viewer-content">
              <div class="scale-controls">
                <b-button-group>
                  <b-button @click="smaller()" size="sm">
                    <i class="fal fa-minus-octagon"></i>
                  </b-button>
                  <b-button @click="bigger()" size="sm">
                    <i class="fal fa-plus-octagon"></i>
                  </b-button>
                </b-button-group>
              </div>
              <canvas ref="pdf0"></canvas>
            </div> 
          </transition>
        </div>
      </b-col>
      <b-col cols="4">
        <div v-if="book.thumbnailUrl !== undefined" class="pdf-description">
          <div class="book-thumbnail">
            <img class="book-cover" :src="host + book.thumbnailUrl" :alt="book.title">
          </div>
          <h5 class="book-title">{{ book.title }}</h5>
          <p class="book-tool book-publish-time"><i class="book-tool-square fas fa-square-full"></i> {{ book.publishYear }}</p>
          <p class="book-tool book-author"><i class="book-tool-square fas fa-square-full"></i> {{ book.author }}</p>
          <p class="book-tool book-type"><i class="book-tool-square fas fa-square-full"></i> {{ book.bookType }}</p>
          <!-- <p class="book-tool pdf-addtime"><i class="book-tool-square fas fa-square-full"></i> {{ book.addTimeMMddyyyyHHmm }}</p> -->
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import pdfjsLib from "pdfjs-dist/lib/pdf.js";
import pdfWorker from "pdfjs-dist/lib/pdf.worker.js";

export default {
  data() {
    return {
      showViewer: false,
      pdfDocument: null,
      book: {},
      pdfUrl: "/20181127185650900.pdf",
      pdfPageIndex: 1,
      pdfScale: 1.5,
      pdfTotalPages: 2,
      pageRendering: false
    };
  },

  computed: {
    host() {
      return this.$store.state.host;
    }
  },

  watch: {
    book(newVal, oldVal) {
      if (newVal === oldVal) return;
      this.readPdfDocument(newVal.bookUrl);
    },
    pdfPageIndex(newVal, oldVal) {
      let totalPages = this.pdfDocument.numPages;
      if (newVal === oldVal) return;
      if (parseInt(newVal) > totalPages) {
        this.pdfTotalPages = totalPages;
      } else {
        this.renderPdfPage(
          parseInt(this.pdfPageIndex),
          this.$refs.pdf0,
          this.pdfScale
        );
      }
    },

    pdfTotalPages(newVal, oldVal) {
      if (newVal === oldVal) return;
      this.$refs.totalPages.innerText = newVal;
    }
  },

  created() {
    let currentBookId = this.$route.query.file.substring(
      0,
      this.$route.query.file.lastIndexOf(".pdf")
    );
    this.getBook(parseInt(currentBookId));
    // this.readPdfDocument(this.pdfUrl);
  },

  methods: {
    smaller() {
      if(this.pdfScale > 1) {
        this.pdfScale -= 0.3;
        this.renderPdfPage(this.pdfPageIndex, this.$refs.pdf0, this.pdfScale);
      }
    },
    bigger() {
      if(this.pdfScale < 3) {
        this.pdfScale += 0.3;
        this.renderPdfPage(this.pdfPageIndex, this.$refs.pdf0, this.pdfScale);
      }
    },
    prevPage() {
      let i = parseInt(this.pdfPageIndex);
      if (i > 1) {
        this.pdfPageIndex = i - 1;
      }
    },
    nextPage() {
      let i = parseInt(this.pdfPageIndex);
      if (i < this.pdfTotalPages) {
        this.pdfPageIndex = i + 1;
      }
    },

    readPdfDocument(url) {
      let totalPages = 0;
      let pageIndex = parseInt(this.pdfPageIndex);
      pdfjsLib.getDocument(url).then(pdfDoc_ => {
        this.pdfDocument = pdfDoc_;
        this.pdfTotalPages = pdfDoc_.numPages;
        this.renderPdfPage(1, this.$refs.pdf0, this.pdfScale);
        let setTimeout1 = setTimeout(() => {
          this.bigger();
          let setTimeout2 = setTimeout(() => {
            this.smaller();
            this.showViewer = true;
            clearTimeout(setTimeout2)
          }, 500);
          clearTimeout(setTimeout1);
        }, 500);
      });
    },

    renderPdfPage(pageIndex, canvas, scale) {
      if (this.pageRendering) return;
      this.pageRendering = true;
      let pageNumPending = null;
      let ctx = canvas.getContext("2d");
      this.pdfDocument.getPage(pageIndex).then(page => {
        let viewport = page.getViewport(scale);
        canvas.height = viewport.height;
        canvas.width = viewport.width;
        let renderContext = {
          canvasContext: ctx,
          viewport: viewport
        };
        let renderTask = page.render(renderContext);
        renderTask.promise.then(() => {
          this.pageRendering = false;
          if (pageNumPending !== null) {
            this.renderPdfPage(pageNumPending);
            pageNumPending = null;
          }
        });
      });
      this.pdfPageIndex = pageIndex;
    },
    getBook(id) {
      this.showViewer = false;
      let fd = new FormData();
      fd.append("language", this.$route.params.ln);
      fd.append("id", id);
      this.$http
        .post(this.host + "/api/qazlatyn/getbook", fd)
        .then(result => {
          if (result.status === 200) {
            if (result.body.status === "success") {
              this.book = result.body.data;
              this.readPdfDocument(this.host + result.body.data.bookUrl);
              this.totalPages = 0;
              this.pageIndex = parseInt(this.pdfPageIndex);
            } else {
              // console.log(result.body.message);
            }
          } else {
            // console.log('Err');
          }
        });
    }
  },

  metaInfo() {
    return {
      title: this.book.title
    };
  }
};
</script>

<style lang="scss">
.pdf-description {
  padding: 1rem;
  background-color: #ffffff;
  border: 1px solid #ededed;

  .book-thumbnail {
    .book-cover {
      width: 100% !important;
    }
  }

  .book-title {
    margin-top: 1.5rem;
    color: #221f20;
    font-size: 1.5rem;
    font-family: 'Open Sans', sans-serif;
    border-bottom: 1px solid #e7e7e7;
    padding-bottom: 0.5rem;
  }

  .book-tool {
    color: #969596;
    font-size: 1rem;
    margin-bottom: 0.25rem;

    .book-tool-square {
      font-size: 0.375rem;
    }
  }

  .book-author {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
  }
}

.pdf-viewer {
  padding: 1rem;
  background-color: #ffffff;
  border: 1px solid #ededed;

  .pdf-viewer-controls {
    padding: 0.5rem;
    background-color: #00849022;
    // border-radius: 0.125rem;
    // box-shadow: 0 0 0.25rem #000000cc;
  }

  .pdf-viewer-content {
    position: relative;
    margin-top: 1rem;
    margin-bottom: 1rem;
    // box-shadow: 0 0 0.25rem #00000077;
    border: 1px solid #00849011;
    overflow: auto;

    .scale-controls {
      position: absolute;
      top: 15px;
      right: 15px;
    }
  }
}

.no-data {
  padding: 1rem 0;
  color: #959595;

  i {
    color: darkorange;
  }
}
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.page-stastic {
  color: #212525;
  font-size: 1rem;
  float: right;
}
.bread-crumb {
  .bread-crumb-items {
    color: #959596;
    font-size: 0.875rem;

    i {
      margin-right: 0.25rem;
    }
  }
}
.bread-crumb-link {
  color: #959696 !important;

  &:hover {
    color: #3477ec !important;
  }
}

/* RTL */

.rtl-layout .pdf-description * {
  direction: rtl;
  text-align: right;
}
.rtl-layout {
  .bread-crumb-items {
    direction: rtl;
    text-align: right;

    .fa-chevron-right {
      transform: rotate(180deg);
    }
  }
}
</style>

<style>
.pdf-viewer {
  position: relative;
  min-height: 500px;
}
.pdf-viewer .pdf-loading {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #00849011;
  top: 0;
}
.pdf-viewer .spinner {
  margin: 250px auto;
  width: 70px;
  text-align: center;
}

.pdf-viewer .spinner > div {
  width: 18px;
  height: 18px;
  background-color: #008490;
  border-radius: 100%;
  display: inline-block;
  -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;
  animation: sk-bouncedelay 1.4s infinite ease-in-out both;
}

.pdf-viewer .spinner .bounce1 {
  -webkit-animation-delay: -0.32s;
  animation-delay: -0.32s;
}

.pdf-viewer .spinner .bounce2 {
  -webkit-animation-delay: -0.16s;
  animation-delay: -0.16s;
}

@-webkit-keyframes sk-bouncedelay {
  0%, 80%, 100% { -webkit-transform: scale(0) }
  40% { -webkit-transform: scale(1.0) }
}

@keyframes sk-bouncedelay {
  0%, 80%, 100% { 
    -webkit-transform: scale(0);
    transform: scale(0);
  } 40% { 
    -webkit-transform: scale(1.0);
    transform: scale(1.0);
  }
}
</style>
